import { createWithEqualityFn } from 'zustand/traditional';

interface AppState {
  themeMode: 'light' | 'dark';
  setThemeMode: (mode: 'light' | 'dark') => void;
  sidebarCollapsed: boolean;          // 桌面端折叠
  sidebarMobileOpen: boolean;         // 移动端打开状态
  toggleSidebar: () => void;          // 通用切换：移动端开关 / 桌面端折叠
  mediaCacheMaxSize: number;
  mediaCacheTTL: number;
  galleryMaxSize: number;
  galleryTTL: number;
  setMediaCacheMaxSize: (size: number) => void;
  setMediaCacheTTL: (ttl: number) => void;
  setGalleryMaxSize: (size: number) => void;
  setGalleryTTL: (ttl: number) => void;
}

export const useAppStore = createWithEqualityFn<AppState>()((set, get) => ({
  themeMode: 'light',
  setThemeMode: (mode) => set({ themeMode: mode }),
  sidebarCollapsed: true,
  sidebarMobileOpen: false,
  toggleSidebar: () => {
    // 根据屏幕宽度决定行为：运行时无法直接取窗口宽度（SSR）这里简单依赖 window 判定
    if (typeof window !== 'undefined' && window.innerWidth < 900) {
      set({ sidebarMobileOpen: !get().sidebarMobileOpen });
    } else {
      set({ sidebarCollapsed: !get().sidebarCollapsed });
    }
  },
  mediaCacheMaxSize: 1024 * 1024 * 1024,
  mediaCacheTTL: 30 * 24 * 60 * 60 * 1000,
  galleryMaxSize: 512 * 1024 * 1024,
  galleryTTL: 7 * 24 * 60 * 60 * 1000,
  setMediaCacheMaxSize: (size) => set({ mediaCacheMaxSize: size }),
  setMediaCacheTTL: (ttl) => set({ mediaCacheTTL: ttl }),
  setGalleryMaxSize: (size) => set({ galleryMaxSize: size }),
  setGalleryTTL: (ttl) => set({ galleryTTL: ttl })
}));
